import { render, staticRenderFns } from "./ViewportBottom.vue?vue&type=template&id=61e7c86d&scoped=true&"
import script from "./ViewportBottom.vue?vue&type=script&lang=js&"
export * from "./ViewportBottom.vue?vue&type=script&lang=js&"
import style0 from "./ViewportBottom.vue?vue&type=style&index=0&id=61e7c86d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e7c86d",
  null
  
)

export default component.exports